import { styled } from "@mui/material";

export const FormError = styled('div')(({ theme }) => ({
    fontSize: "12px",
    color: "red"
}));

export const FormSuggestion = styled('div')(({ theme }) => ({
    margin: "0",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "13px",
    color: "#1C61F4",
    marginTop: "2px"
}));
